var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_127_5596",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_127_5596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.025 15.05V23C25.025 23.55 24.8291 24.0208 24.4375 24.4125C24.0458 24.8042 23.575 25 23.025 25H9.02497C8.47497 25 8.00413 24.8042 7.61247 24.4125C7.2208 24.0208 7.02497 23.55 7.02497 23V15.05C6.64163 14.7 6.3458 14.25 6.13747 13.7C5.92913 13.15 5.92497 12.55 6.12497 11.9L7.17497 8.5C7.3083 8.06667 7.5458 7.70833 7.88747 7.425C8.22913 7.14167 8.62497 7 9.07497 7H22.975C23.425 7 23.8166 7.1375 24.15 7.4125C24.4833 7.6875 24.725 8.05 24.875 8.5L25.925 11.9C26.125 12.55 26.1208 13.1417 25.9125 13.675C25.7041 14.2083 25.4083 14.6667 25.025 15.05ZM18.225 14C18.675 14 19.0166 13.8458 19.25 13.5375C19.4833 13.2292 19.575 12.8833 19.525 12.5L18.975 9H17.025V12.7C17.025 13.05 17.1416 13.3542 17.375 13.6125C17.6083 13.8708 17.8916 14 18.225 14ZM13.725 14C14.1083 14 14.4208 13.8708 14.6625 13.6125C14.9041 13.3542 15.025 13.05 15.025 12.7V9H13.075L12.525 12.5C12.4583 12.9 12.5458 13.25 12.7875 13.55C13.0291 13.85 13.3416 14 13.725 14ZM9.27497 14C9.57497 14 9.83747 13.8917 10.0625 13.675C10.2875 13.4583 10.425 13.1833 10.475 12.85L11.025 9H9.07497L8.07497 12.35C7.97497 12.6833 8.02913 13.0417 8.23747 13.425C8.4458 13.8083 8.79163 14 9.27497 14ZM22.775 14C23.2583 14 23.6083 13.8083 23.825 13.425C24.0416 13.0417 24.0916 12.6833 23.975 12.35L22.925 9H21.025L21.575 12.85C21.625 13.1833 21.7625 13.4583 21.9875 13.675C22.2125 13.8917 22.475 14 22.775 14Z",
    fill: "#686868"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.12b62edfbcece527e5f4ffca3fc4446d.svg";
export { ForwardRef as ReactComponent };